import { Injectable } from '@angular/core';

@Injectable()
export class HomeService {

  constructor() { }

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/home.service.ts